import { ApolloError } from '@apollo/client'
import { useRouter } from 'next/router'
import { useCallback } from 'react'
import { useApolloErrorToast } from 'src/hooks/useApolloErrorToast'
import { pagesPath } from 'src/routes/$path'

export const useLoginErrorHandler = ({
  onAccountLocked,
}: {
  onAccountLocked?: () => void
} = {}) => {
  const router = useRouter()
  const apolloErrorToast = useApolloErrorToast()

  return useCallback(
    (error: ApolloError) => {
      const detailedCode = error.graphQLErrors?.[0]?.extensions?.['detailed_code']
      if (detailedCode === 'NO_ELIGIBLE_PHARMACY_MEMBERSHIP') {
        router.push(pagesPath.unauthorized.$url())
        return
      }
      if (detailedCode === 'LOGIN_ACCOUNT_LOCKED') {
        onAccountLocked?.()
        return
      }
      apolloErrorToast(error)
    },
    [router, apolloErrorToast, onAccountLocked],
  )
}
